import type { SVGProps } from "react";

type IconProps = { size?: number } & SVGProps<SVGSVGElement>;

function base(size: number, props: SVGProps<SVGSVGElement>) {
  return {
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.8,
    strokeLinecap: "round" as const,
    strokeLinejoin: "round" as const,
    ...props,
  };
}

export function IconCamera({ size = 24, ...props }: IconProps) {
  return (
    <svg {...base(size, props)} aria-hidden>
      <path d="M4 8.5A2 2 0 0 1 6 6.5h1.6l1-1.6h4.8l1 1.6H18a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2Z" />
      <circle cx="12" cy="12.5" r="3.1" />
    </svg>
  );
}

export function IconDice({ size = 24, ...props }: IconProps) {
  return (
    <svg {...base(size, props)} aria-hidden>
      <rect x="4" y="4" width="16" height="16" rx="4.5" />
      <circle cx="9" cy="9" r="1.15" fill="currentColor" stroke="none" />
      <circle cx="15" cy="9" r="1.15" fill="currentColor" stroke="none" />
      <circle cx="12" cy="12" r="1.15" fill="currentColor" stroke="none" />
      <circle cx="9" cy="15" r="1.15" fill="currentColor" stroke="none" />
      <circle cx="15" cy="15" r="1.15" fill="currentColor" stroke="none" />
    </svg>
  );
}

export function IconSparkles({ size = 24, ...props }: IconProps) {
  return (
    <svg {...base(size, props)} aria-hidden>
      <path d="M12 3.2l1.7 4.6 4.6 1.7-4.6 1.7L12 15.8l-1.7-4.6-4.6-1.7 4.6-1.7Z" />
      <path d="M18.2 14.5l.8 2 2 .8-2 .8-.8 2-.8-2-2-.8 2-.8Z" />
    </svg>
  );
}

export function IconRefresh({ size = 24, ...props }: IconProps) {
  return (
    <svg {...base(size, props)} aria-hidden>
      <path d="M20 11.5a8 8 0 1 0-2 5.3" />
      <path d="M20 4.5v5h-5" />
    </svg>
  );
}

export function IconDownload({ size = 24, ...props }: IconProps) {
  return (
    <svg {...base(size, props)} aria-hidden>
      <path d="M12 3.5v11" />
      <path d="M7.5 10.5 12 15l4.5-4.5" />
      <path d="M4.5 20h15" />
    </svg>
  );
}

export function IconShare({ size = 24, ...props }: IconProps) {
  return (
    <svg {...base(size, props)} aria-hidden>
      <circle cx="18" cy="5.5" r="2.6" />
      <circle cx="6" cy="12" r="2.6" />
      <circle cx="18" cy="18.5" r="2.6" />
      <path d="M8.3 10.8 15.7 6.7" />
      <path d="M8.3 13.2 15.7 17.3" />
    </svg>
  );
}

export function IconLink({ size = 24, ...props }: IconProps) {
  return (
    <svg {...base(size, props)} aria-hidden>
      <path d="M9.6 14.4 14.4 9.6" />
      <path d="M8.2 12 6.4 13.8a3.5 3.5 0 0 0 4.95 4.95L13.2 17" />
      <path d="M15.8 12l1.8-1.8a3.5 3.5 0 0 0-4.95-4.95L10.8 7" />
    </svg>
  );
}

export function IconClose({ size = 24, ...props }: IconProps) {
  return (
    <svg {...base(size, props)} aria-hidden>
      <path d="M6 6l12 12" />
      <path d="M18 6 6 18" />
    </svg>
  );
}

export function IconX({ size = 24, ...props }: IconProps) {
  return (
    <svg {...base(size, props)} aria-hidden>
      <path
        d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24h-6.66l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"
        fill="currentColor"
        stroke="none"
      />
    </svg>
  );
}
